import React, { memo } from "react";
import { Table, OverlayTrigger, Tooltip } from "@themesberg/react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
	faArrowCircleDown,
	faArrowCircleUp,
	faCheckCircle,
	faExclamationTriangle,
} from "@fortawesome/free-solid-svg-icons";
import { format } from "date-fns";
import Trigger from "../../../../components/OverlayTrigger";
import ActionMenu from "../ActionMenu";

const renderCell = (accessor, user, navigate, setRestoreUser) => {
	switch (accessor) {
		case "username":
			return user.username ? (
				<div className="d-flex align-items-center gap-1">
					<Trigger message={user.username}>
						<span
							style={{ width: "100px", cursor: "pointer" }}
							className={user.isDeleted  ? " d-inline-block text-truncate": "text-link d-inline-block text-truncate"}
							onClick={() => user.isDeleted ? {} :navigate(`/admin/users/details/${user.userId}`)}
						>
							{user.username}
						</span>
					</Trigger>
					{user.isSuspicious ? (
						<OverlayTrigger
							placement="top"
							overlay={<Tooltip id="suspicious-tooltip">Suspicious</Tooltip>}
						>
							<FontAwesomeIcon
								icon={faExclamationTriangle}
								className="text-warning"
								style={{ cursor: "pointer" }}
							/>
						</OverlayTrigger>
					) : user.isVerified ? (
						<OverlayTrigger
							placement="top"
							overlay={<Tooltip id="verified-tooltip">Verified</Tooltip>}
						>
							<FontAwesomeIcon
								icon={faCheckCircle}
								className="text-success"
								style={{ cursor: "pointer" }}
							/>
						</OverlayTrigger>
					) : null}
				</div>
			) : "N/A";

		case "profileNotes":
			return user.other?.profileNotes ? (
				<OverlayTrigger
					placement="top"
					overlay={<Tooltip id="profile-notes">{user.other.profileNotes}</Tooltip>}
				>
					<span style={{
						display: "inline-block",
						width: "100%",
						overflow: "hidden",
						textOverflow: "ellipsis",
						whiteSpace: "nowrap"
					}}>
						{user.other.profileNotes}
					</span>
				</OverlayTrigger>
			) : "-";

		case "isActive":
			return user.isActive ? (
				<span className="text-success">Active</span>
			) : (
				<span className="text-danger">In Active</span>
			);

			case "affiliateStatus":
  return user.affiliateStatus ? (
    <span className="text-success">Affiliated</span>
  ) : (
    <span className="text-danger">Not Affiliated</span>
  );

// affiliateStatus
		case "createdAt":
			return user.createdAt
				? format(new Date(user.createdAt), "dd MMM yyyy")
				: "-";

		case "registrationSource":
			return "Normal"; // Replace with user.registrationSource if dynamic

		case "action":
			return <ActionMenu userId={user.userId} navigate={navigate} isDeleted={user.isDeleted} userDerails={user} setRestoreUser={setRestoreUser} />;

		default:
			return user[accessor] ?? "-";
	}
};

const UsersTable = memo(({
	loading,
	userData,
	navigate,
	selected,
	sortBy,
	over,
	setOver,
	setSortBy,
	setOrderBy,
	tableHeaders,
	tableMaxHeight,
	restoreUser, setRestoreUser,
    onHandleRestoreduser
}) => {
	console.log({ tableHeaders , restoreUser, setRestoreUser,
		onHandleRestoreduser}, "columnssssssssssssssss table prop")
	return (
		<div style={{ maxHeight: tableMaxHeight }}>


			<Table striped responsive hover size="sm" className="text-center mt-3">
				<thead className="thead-light">
					<tr>
						{tableHeaders.map((h, idx) => (
							<th
								key={idx}
								onClick={() =>
									["email", "userId", "username"].includes(h.value) &&
									setOrderBy(h.value)
								}
								style={{ cursor: "pointer" }}
								className={selected(h) ? "border-3 border border-blue" : ""}
							>
								{h.label}{" "}
								{selected(h) && (
									<FontAwesomeIcon
										style={over ? { color: "red" } : {}}
										icon={sortBy === "asc" ? faArrowCircleUp : faArrowCircleDown}
										onClick={() => setSortBy(sortBy === "asc" ? "desc" : "asc")}
										onMouseOver={() => setOver(true)}
										onMouseLeave={() => setOver(false)}
									/>
								)}
							</th>
						))}
					</tr>
				</thead>


				<tbody id={loading ? "cover-spin" : ""}>
					{!loading && Boolean(userData) && userData.length > 0 && (
						userData.map((user) => (
							<tr
								key={user.userId}
								style={{
									opacity: user.isDeleted ? '0.5' : '' // light red background if true
								}}
							>
								{tableHeaders.map((h, idx) => (
									<td key={idx}>
										{renderCell(h.accessor, user, navigate, setRestoreUser)}
									</td>
								))}
							</tr>
						))
					)}

					{!loading && userData?.length === 0 && (
						<tr>
							<td colSpan={13} className="text-danger text-center">
								No data found
							</td>
						</tr>
					)}
				</tbody>

			</Table>
		</div>
	);
});

export default UsersTable;
